// Copyright year baked at build time so the footer does not hydrate-mismatch.
// Calendar links do not use this. Those follow currentCalendarYear() in
// src/lib/calendarYear.ts, the same Denver year the edge redirect uses.
export const BUILD_YEAR: number =
  typeof __BUILD_YEAR__ !== 'undefined' ? __BUILD_YEAR__ : new Date().getFullYear();
